<template>
  <div class="container">
    <div
      class="flex mt12"
      v-for="(cItem, CIndex) in fItem.activityFieldCondition.children"
      :key="cItem.name"
    >
      <div>逻辑任务内容</div>

      <el-select
        v-model="cItem.activityTaskType"
        placeholder="请选择任务内容"
        clearable
        :style="{ width: '100%' }"
      >
        <el-option
          v-for="(item, index) in taskTypeMap[form.activityTaskModuleType]"
          :key="index"
          :label="item.activityTaskFieldDesc"
          :value="item.activityTaskName"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="cItem.conditionType"
        placeholder="请选择操作符"
        clearable
        :style="{ width: '100%' }"
      >
        <el-option
          v-for="(item, index) in logicOpListArr"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="cItem.coin"
        placeholder="请选择币种"
        clearable
        :style="{ width: '100%' }"
      >
        <el-option
          v-for="(item, index) in coinOptions2"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        v-model="cItem.taskTypeArgs"
        class="searchIpt"
        placeholder="数量"
      ></el-input>
      <div class="addTask">
        <el-button size="mini" type="primary" @click="handleAddTask(cItem)"
          >添加任务</el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="
            handleDelTask(cItem, CIndex, fItem.activityFieldCondition.children)
          "
          >删除任务</el-button
        >
      </div>
      <TaskList
        v-if="cItem.children && cItem.children.length"
        @handleAddTask="handleAddTask"
        @handleDelTask="handleDelTask"
        :fItem="cItem"
        :form="form"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'TaskList',
  props: ['fItem', 'form'],
  data() {
    return {
      coinOptions2: [
        {
          label: 'USDT',
          value: 0,
        },
      ],
    }
  },
  computed: {
    ...mapState('management', ['taskTypeList', 'lotteryList']),
    ...mapGetters('management', ['logicOpListArr', 'taskTypeMap']),
  },
  methods: {
    handleAddTask(cItem) {
      this.$emit('handleAddTask', cItem)
    },
    handleDelTask(cItem, index, arr) {
      this.$emit('handleDelTask', index, cItem, arr)
    },
  },
}
</script>
<style lang="less" scoped>
.langTab {
  cursor: pointer;
  margin-right: 20px;
  display: inline-block;
}
.container {
}

.flex {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  border: 1px solid #1e1e1e;
  padding: 12px;
}
.mt12 {
  margin-top: 12px;
}
.addTask {
}
</style>
